export default __webpack_public_path__ + "static/sarpl-logo-white-a7030a88bd19799fc31139c13db116a0.png";